// extracted by mini-css-extract-plugin
module.exports = {"ResultsTable":"ResultsTable_ResultsTable__3EmRs","table":"ResultsTable_table__3gUHB"};